export default __webpack_public_path__ + "static/media/favicon.244f25f2.ico";